module.exports = __webpack_public_path__ + "static/speako-6d3f8ee49bca8abaebb838ae482828ea.png";